var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _c(
            "el-row",
            { staticStyle: { margin: "5px 0" } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.QSPI_STOCKRECOVER_SUBMIT,
                      expression: "QSPI_STOCKRECOVER_SUBMIT",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onSubmit("submit")
                    },
                  },
                },
                [_vm._v("提交")]
              ),
              _vm.detailForm.ttQspiStockRecHeaderId
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_STOCKRECOVER_FINISH,
                          expression: "QSPI_STOCKRECOVER_FINISH",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onSubmit("close")
                        },
                      },
                    },
                    [_vm._v("结案")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "within_box" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "form_box" },
              [
                _c(
                  "el-form",
                  {
                    ref: "detailForm",
                    attrs: {
                      model: _vm.detailForm,
                      rules: _vm.rules,
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "SR编号", prop: "srNumber" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.srNumber,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "srNumber", $$v)
                                    },
                                    expression: "detailForm.srNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "回收启动日期",
                                  prop: "recoveryStartDate",
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.recoveryStartDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "recoveryStartDate",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.recoveryStartDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "回收项目简介",
                                  prop: "recoveryProjectSummary",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value:
                                      _vm.detailForm.recoveryProjectSummary,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "recoveryProjectSummary",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "detailForm.recoveryProjectSummary",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "已结案", prop: "isClosed" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.isClosed,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "isClosed",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.isClosed",
                                    },
                                  },
                                  _vm._l(
                                    _vm.isClosedLists,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "SR等级", prop: "srGrade" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.srGrade,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.detailForm, "srGrade", $$v)
                                      },
                                      expression: "detailForm.srGrade",
                                    },
                                  },
                                  _vm._l(
                                    _vm.srGradeLists,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "发起人", prop: "createBy" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.createBy,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "createBy", $$v)
                                    },
                                    expression: "detailForm.createBy",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态", prop: "status" } },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: "",
                                    table: "TT_QSPI_STOCK_REC_HEADER",
                                    field: "STATUS",
                                  },
                                  model: {
                                    value: _vm.detailForm.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "status", $$v)
                                    },
                                    expression: "detailForm.status",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "原因", prop: "reason" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.reason,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "reason", $$v)
                                    },
                                    expression: "detailForm.reason",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "备注", prop: "remarks" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.remarks,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "remarks", $$v)
                                    },
                                    expression: "detailForm.remarks",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "tab_box" },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "产品明细", name: "tab1" } },
                    [
                      _c(
                        "el-row",
                        { staticStyle: { "margin-bottom": "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.onAdd("Save")
                                },
                              },
                            },
                            [_vm._v("新增")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "mini", type: "danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.onDel("Save")
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.onCopy("Save")
                                },
                              },
                            },
                            [_vm._v("复制行")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "ux-grid",
                        {
                          ref: "plxTable1",
                          attrs: {
                            data: _vm.tableData1,
                            "keep-source": "",
                            "max-height": "500",
                            "show-overflow": "tooltip",
                            "highlight-current-row": "",
                          },
                          on: { "selection-change": _vm.selectionChange },
                        },
                        [
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              type: "checkbox",
                              width: "80",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "操作",
                              width: "80",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onModify(
                                              scope.row,
                                              scope
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "序号",
                              type: "index",
                              width: "60",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "产品编号",
                              field: "eightBitCode",
                              "min-width": "100",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "产品名称",
                              field: "eightBitCodeName",
                              "min-width": "100",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "结算单位名称",
                              field: "supplierName",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "Facility名称",
                              field: "facilityName",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "产品批次",
                              field: "batchNo",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "涉及DCs",
                              field: "relatedDcName",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "Regions",
                              field: "regoins",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "回收范围",
                              field: "recoveryScope",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("ic")(
                                            scope.row.recoveryScope,
                                            "TT_QSPI_STOCK_REC_ITEM",
                                            "RECOVERY_SCOPE"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "餐厅回收数量(箱)",
                              field: "restaurantRecoveryQty",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "DC回收数量(箱)",
                              field: "dcRecoveryQty",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "回收数量(箱)",
                              field: "recoveryQty",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "处理结果",
                              field: "handlingResultI18n",
                              "min-width": "120",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "附件上传", name: "tab2" } },
                    [
                      _c(
                        "el-row",
                        { staticStyle: { "margin-bottom": "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.onUpload },
                            },
                            [_vm._v("上传")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          ref: "plxTable2",
                          attrs: {
                            data: _vm.tableData2,
                            "max-height": "500",
                            border: "",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作",
                              width: "80",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delFile(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "附件大类",
                              prop: "attachmentLargeCategory",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "附件子类",
                              prop: "attachmentSmallCategory",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "附件名称",
                              prop: "fileName",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDownload(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.fileName))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "上传人",
                              prop: "uploadBy",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "上传时间",
                              prop: "uploadTime",
                              "show-overflow-tooltip": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "操作日志", name: "tab3" } },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "plxTable3",
                          attrs: {
                            data: _vm.tableData3,
                            "max-height": "500",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作时间",
                              prop: "operateTime",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作人",
                              prop: "operateBy",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作描述",
                              prop: "operateDesc",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "产品明细",
            visible: _vm.dialogEditVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogEditVisible = $event
            },
            close: _vm.onCancel,
          },
        },
        [
          _c(
            "el-form",
            { ref: "editForm", attrs: { model: _vm.editForm } },
            [
              _c(
                "el-table",
                {
                  ref: "editDataRef",
                  staticClass: "stockRecovery_table",
                  attrs: {
                    data: _vm.editForm.editData,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "eightBitCode",
                      label: "产品编号",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "eightBitCodeName",
                      label: "产品名称",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "supplierName",
                      label: "结算单位名称",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "facilityName",
                      label: "Facility名称",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "batchNo",
                      label: "产品批次",
                      "render-header": _vm.renderHeader,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `editData.${scope.$index}.batchNo`,
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: scope.row.batchNo,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "batchNo", $$v)
                                    },
                                    expression: "scope.row.batchNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "relatedDcCode",
                      label: "涉及DCs",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `editData.${scope.$index}.relatedDcCode`,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: scope.row.relatedDcCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "relatedDcCode",
                                          $$v
                                        )
                                      },
                                      expression: "scope.row.relatedDcCode",
                                    },
                                  },
                                  _vm._l(
                                    _vm.relatedDcCodeLists,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.dcName,
                                          value: item.dcCode,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "regoins",
                      label: "Regions",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `editData.${scope.$index}.regoins`,
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: scope.row.regoins,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "regoins", $$v)
                                    },
                                    expression: "scope.row.regoins",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      sortable: "",
                      prop: "recoveryScope",
                      label: "回收范围",
                      "render-header": _vm.renderHeader,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `editData.${scope.$index}.recoveryScope`,
                                },
                              },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    table: "TT_QSPI_STOCK_REC_ITEM",
                                    field: "RECOVERY_SCOPE",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.recoveryScopeChange(
                                        scope.row,
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: scope.row.recoveryScope,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "recoveryScope", $$v)
                                    },
                                    expression: "scope.row.recoveryScope",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      sortable: "",
                      prop: "restaurantRecoveryQty",
                      label: "餐厅回收数量(箱)",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `editData.${scope.$index}.restaurantRecoveryQty`,
                                  rules: _vm.restaurantRecoveryQtyRules(
                                    scope.$index,
                                    scope.row
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: scope.row.recoveryScope === "DC",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.restaurantRecoveryQtyChange(
                                        scope.row,
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: scope.row.restaurantRecoveryQty,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "restaurantRecoveryQty",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "scope.row.restaurantRecoveryQty",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      sortable: "",
                      prop: "dcRecoveryQty",
                      label: "DC回收数量(箱)",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `editData.${scope.$index}.dcRecoveryQty`,
                                  rules: _vm.dcRecoveryQtyRules(
                                    scope.$index,
                                    scope.row
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled:
                                      scope.row.recoveryScope === "Restaurant",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.dcRecoveryQtyChange(
                                        scope.row,
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: scope.row.dcRecoveryQty,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "dcRecoveryQty", $$v)
                                    },
                                    expression: "scope.row.dcRecoveryQty",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      sortable: "",
                      prop: "recoveryQty",
                      label: "回收数量(箱)",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      sortable: "",
                      prop: "handlingResult",
                      label: "处理结果",
                      "render-header": _vm.renderHeader,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `editData.${scope.$index}.handlingResult`,
                                },
                              },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    table: "TT_QSPI_STOCK_REC_ITEM",
                                    field: "HANDLING_RESULT",
                                    multiple: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handlingResultChange(
                                        $event,
                                        scope.$index,
                                        _vm.editForm.editData
                                      )
                                    },
                                  },
                                  model: {
                                    value: scope.row.handlingResult,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "handlingResult", $$v)
                                    },
                                    expression: "scope.row.handlingResult",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { type: "flex", justify: "center" },
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onCancel } },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "附件上传",
            visible: _vm.dialogUploadVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUploadVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "uploadForm",
              attrs: {
                model: _vm.uploadForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "附件大类",
                            prop: "attachmentLargeCategory",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                              },
                              on: { change: _vm.attachmentLargeCategoryChange },
                              model: {
                                value: _vm.uploadForm.attachmentLargeCategory,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.uploadForm,
                                    "attachmentLargeCategory",
                                    $$v
                                  )
                                },
                                expression:
                                  "uploadForm.attachmentLargeCategory",
                              },
                            },
                            _vm._l(
                              _vm.attachmentLargeCategoryLists,
                              function (item, index) {
                                return _c(
                                  "el-option",
                                  {
                                    key: index,
                                    attrs: {
                                      label: item.attachmentCategory,
                                      value: item.attachmentCategory,
                                    },
                                  },
                                  [
                                    item.isMandatory === "Y"
                                      ? _c("i", { staticClass: "mandatory" })
                                      : _vm._e(),
                                    _c("span", [
                                      _vm._v(_vm._s(item.attachmentCategory)),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "附件子类",
                            prop: "attachmentSmallCategory",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.uploadForm.attachmentSmallCategory,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.uploadForm,
                                    "attachmentSmallCategory",
                                    $$v
                                  )
                                },
                                expression:
                                  "uploadForm.attachmentSmallCategory",
                              },
                            },
                            _vm._l(
                              _vm.attachmentSmallCategoryLists,
                              function (item, index) {
                                return _c(
                                  "el-option",
                                  {
                                    key: index,
                                    attrs: {
                                      label: item.attachmentCategory,
                                      value: item.attachmentCategory,
                                    },
                                  },
                                  [
                                    item.isMandatory === "Y"
                                      ? _c("i", { staticClass: "mandatory" })
                                      : _vm._e(),
                                    _c("span", [
                                      _vm._v(_vm._s(item.attachmentCategory)),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "fileName" } },
                        [
                          _c("el-input", {
                            attrs: { readonly: "" },
                            model: {
                              value: _vm.uploadForm.fileName,
                              callback: function ($$v) {
                                _vm.$set(_vm.uploadForm, "fileName", $$v)
                              },
                              expression: "uploadForm.fileName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          attrs: {
                            headers: _vm.header,
                            action: _vm.uploadUrl,
                            "on-success": _vm.uploadSuccess,
                            "on-change": _vm.handleChange,
                            "before-upload": _vm.beforeUpload,
                            "file-list": _vm.fileList,
                            limit: 1,
                            "auto-upload": false,
                            "show-file-list": false,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "small", type: "primary" } },
                            [_vm._v("选取文件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.submitUpload },
                    },
                    [_vm._v("上传")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onCloseFileDialog },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "产品名称选择",
            visible: _vm.dialogProVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogProVisible = $event
            },
            close: _vm.onClosePro,
          },
        },
        [_c("selProDialog", { on: { setSelPro: _vm.setSelPro } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title_box" }, [
      _c("p", { staticClass: "line" }),
      _c("p", { staticClass: "title" }, [_vm._v("Case Detail")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }